import { stateDropdown } from '@/fetchers/backend-fetchers';
import { useQuery } from '@tanstack/react-query';

export const useStateDropdown = () => {
  const { data: stateDropdown_, isLoading } = useQuery({
    queryKey: ['state-dropdown'],
    queryFn: stateDropdown,
    select: (data) => data?.data,
  });

  return { stateDropdown_, isLoading };
};
